export const htmlEncode = (markup:string): string =>
	(document.createElement('div').appendChild(document.createTextNode(markup)).parentNode as HTMLElement)?.innerHTML || '';

export const htmlDecode = (html: string): string => {
	const a: HTMLDivElement = document.createElement('div');
	a.innerHTML = html;
	return a.textContent ?? '';
};
